import React, { useState } from 'react';
import { updatePassword } from '../services/api';
import '../styles/UpdatePassword.css';

const UpdatePassword = () => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [reEnterNewPassword, setReEnterNewPassword] = useState('');
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');

    const handleUpdatePassword = async (e) => {
        e.preventDefault();
        if (newPassword !== reEnterNewPassword) {
            setMessage("Passwords do not match!");
            setMessageType('error');
            return;
        }

        const token = localStorage.getItem('adminToken');
        try {
            await updatePassword(token, currentPassword, newPassword);
            setMessage('Password updated successfully!');
            setMessageType('success');
            setCurrentPassword('');
            setNewPassword('');
            setReEnterNewPassword('');
        } catch (error) {
            setMessage('Password update failed: ' + error.response?.data?.message || error.message);
            setMessageType('error');
        }
    };

    return (
        <div className="password-change-wrapper password-change-container">
            <div className="password-change-header">
                <h2>Update Password</h2>
            </div>

            {message && (
                <div className={`alert ${messageType === 'success' ? 'alert-success' : 'alert-error'}`}>
                    {message}
                </div>
            )}

            <div className="password-form-container">
                <form onSubmit={handleUpdatePassword}>
                    <div className="form-group">
                        <label className="form-label">Current Password</label>
                        <input
                            type="password"
                            className="form-control"
                            placeholder="Enter current password"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label">New Password</label>
                        <input
                            type="password"
                            className="form-control"
                            placeholder="Enter new password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label">Re-enter New Password</label>
                        <input
                            type="password"
                            className="form-control"
                            placeholder="Re-enter new password"
                            value={reEnterNewPassword}
                            onChange={(e) => setReEnterNewPassword(e.target.value)}
                            required
                        />
                    </div>

                    <button type="submit" className="btn-submit">
                        Update Password
                    </button>
                </form>
            </div>
        </div>
    );
};

export default UpdatePassword;
